export const NAMES = {
  TAG_NAME: "ab-data-sheet",
  CSS_CLASSES: {
    ROOT : 'ab-data-sheet',
    ROOT_LAYOUT_COMPACT : 'ab-data-sheet--compact',
    ROOT_STICKY : 'ab-data-sheet--sticky',
    ROOT_PRODUCT_COUNT_PREFIX : 'ab-data-sheet--n',
    ROOT_COMPARE_BOX_SHOWN: 'ab-data-sheet--compare-box-shown',
    TRIGGER_REMOVE_ITEM: 'remove-item-trigger',
    TRIGGER_SHOW_COMPARE_BOX: 'ab-data-sheet__compare-cta--show',
    TRIGGER_HIDE_COMPARE_BOX: 'ab-data-sheet__compare-cta--hide',
    COMPARE_AREA: 'ab-data-sheet__compare',
    COMPARE_BOX_CTA: 'ab-data-sheet__compare-cta',
    COMPARE_BOX_INSTRUCTION: 'ab-data-sheet__compare-instruction',
  },
}